import { RootState } from "../../RootReducer";

export const selectNotifications = (state: RootState) => state.notification.notifications;
export const selectActiveNotifications = (state: RootState) =>
    state.notification.notifications.filter((notification) => !notification.hidden);
